<template>

    <section id="new_ref_third_step" class="flex ">

        <titlePage>
            <template slot="titleHead">
                <div class="hero-head has-text-centered" >
                    <h1 class="title has-text-weight-light is-size-1 ">{{ currentRef.name }}</h1>
                    <h2 class="associated_ref_name">{{ $t('modules.refs.formStep3.associatedRef') }} : <span>{{ getRefName(associatedRef) }}</span></h2>
                </div>
            </template>
        </titlePage>

        <div class="hero">
            <div class="title_notice_line">
                <div class="coeffs_heading container">
                    <h1 class="page-title title is-size-2 has-text-weight-bold">{{ $t('modules.refs.formStep3.title') }}</h1>
                    <notifText v-html="$t('modules.refs.formStep3.globalNotice')" />
                </div>
            </div>

            <div class="hero-body">
                <div class="widget_helpers container">
                    <div class="columns">
                        <div class="column">
                            <div class="total_slider_container" :class="statusClass">
                                <CoeffSlider :disabled="true" coeff-id="total" :label="$t('modules.refs.formStep3.coeffTotal')" :ref-coeff="totalCoeffs" @change="syncVal" />
                            </div>
                        </div>
                        <div class="column">
                            <div class="model_align_btn " @click="syncCoeffs" :class="{active: isAligned}" v-if="!notOwnedRef">
                                <span>{{ $t('modules.refs.formStep3.SyncRefButton') }}</span>
                                <div class="btn_tick">
                                    <div class="btn_inner_tick"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container bottom-section">
                    <div class="columns">
                        <div class="column">
                            <div class="scores_columns_container">
                                <h3 class="dim_cat_title coeff_cat_title">{{ $t('dimensions.skills_titles.title1') }}</h3>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r1" :ref-coeff="coeffs.r1"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r2" :ref-coeff="coeffs.r2"  @change="syncVal" :disabled="notOwnedRef"/>
                                <h3 class="dim_cat_title coeff_cat_title">{{ $t('dimensions.skills_titles.title3') }}</h3>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r8" :ref-coeff="coeffs.r8"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r9" :ref-coeff="coeffs.r9"  @change="syncVal" :disabled="notOwnedRef"/>
                            </div>
                        </div>

                        <div class="column">
                            <div class="scores_columns_container">
                                <h3 class="dim_cat_title coeff_cat_title">{{ $t('dimensions.skills_titles.title4') }}</h3>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r10" :ref-coeff="coeffs.r10"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r11" :ref-coeff="coeffs.r11"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r12" :ref-coeff="coeffs.r12"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r13" :ref-coeff="coeffs.r13"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r14" :ref-coeff="coeffs.r14"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r15" :ref-coeff="coeffs.r15"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r16" :ref-coeff="coeffs.r16"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r17" :ref-coeff="coeffs.r17"  @change="syncVal" :disabled="notOwnedRef"/>
                            </div>
                        </div>
                        <div class="column">
                            <div class="scores_columns_container">
                                <h3 class="dim_cat_title coeff_cat_title">{{ $t('dimensions.skills_titles.title2') }}</h3>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r3" :ref-coeff="coeffs.r3"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r4" :ref-coeff="coeffs.r4"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r5" :ref-coeff="coeffs.r5"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r6" :ref-coeff="coeffs.r6"  @change="syncVal" :disabled="notOwnedRef"/>
                                <CoeffSlider :first-friend="selectedFriend1" :second-friend="selectedFriend2" coeff-id="r7" :ref-coeff="coeffs.r7"  @change="syncVal" :disabled="notOwnedRef"/>
                            </div>
                        </div>
                    </div>
                    <div class="has-text-centered" v-if="isNew">
                        <btn-circle-icon v-bind:class="{disabled: !isFormValid}" class="large" icon="icon-arrow-right" @click.native="nextStep" />
                    </div>

                    <FriendsDropdown  v-if="hasFriends"
                        @firstFriendChange="firstFriendChange"
                        @secondFriendChange="secondFriendChange"
                        :sightRefFriends="sightRefFriends" />

                </div>
            </div>

        <transition name="notif-slide-up">
            <alert v-if="showErrorNotif" context="danger" @close="showErrorNotif=false">{{ $t('modules.refs.formStep3.coeffErrorAlert') }}</alert>
        </transition>

        </div>
    </section>
</template>

<script>
import titlePage from "@/components/layouts/titlePage"
import FriendsDropdown from "./friendsDropdown"

export default {
    name: 'FormStep4',
    props: ['isNew', "notOwnedRef"],
    components: {
        titlePage,
        FriendsDropdown
    },
    data(){
        return {
            showErrorNotif: false,
            selectedFriend1: null,
            selectedFriend2: null
        }
    },
    computed: {
        currentRef(){
            return this.$store.state.RefStore.currentRef
        },
        associatedRef(){
            return this.$store.state.RefStore.currentRef.associated_ref
        },
        coeffs(){
            return this.$store.state.RefStore.currentRef.coeffs
        },
        totalCoeffs(){
            return (
                this.coeffs.r1 + this.coeffs.r2 + this.coeffs.r5 + this.coeffs.r8 + this.coeffs.r6 + this.coeffs.r11
                + this.coeffs.r14 + this.coeffs.r13 + this.coeffs.r15 + this.coeffs.r16 + this.coeffs.r17
                + this.coeffs.r3 + this.coeffs.r7 + this.coeffs.r12 + this.coeffs.r4 + this.coeffs.r9 + this.coeffs.r10
            )
        },
        totalStatus(){
            if(this.totalCoeffs < 500){  return 'down'  }
            else if(this.totalCoeffs == 500){  return 'valid'  }
            else{  return 'up'  }
        },
        statusClass(){
            return this.totalStatus
        },
        isFormValid(){
            return (this.totalStatus == 'valid')
        },
        isAligned(){
            return JSON.stringify(this.coeffs) ===  JSON.stringify(this.associatedRef.coeffs)
        },
        sightRefFriends(){
            return this._.filter(this.currentRef.sight_ref_friends, function(o) { return o.completed; });
        },
        hasFriends(){
            if (this.sightRefFriends){
                return this.sightRefFriends.length > 0
            }else{
                return false
            }
        }

    },
    mounted(){
        const emptyCoeffs = JSON.stringify({"r1":0,"r2":0,"r3":0,"r4":0,"r5":0,"r6":0,"r7":0,"r8":0,"r9":0,"r10":0,"r11":0,"r12":0,"r13":0,"r14":0,"r15":0,"r16":0,"r17":0})
        if(JSON.stringify(this.coeffs) === emptyCoeffs){ this.syncCoeffs() }
        this.$store.commit('RefStore/updateFormValidity', { index: 3, validity: this.isFormValid } )
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        syncVal(coeffData){
            const objectToSend = {coeffs: { } }
            objectToSend.coeffs[coeffData.id] = coeffData.val
            this.$store.commit('RefStore/updateRefData', objectToSend )
            this.$store.commit('RefStore/updateFormValidity', { index: 3, validity: this.isFormValid } )

        },
        syncCoeffs(){
            const objectToSend = { coeffs: this.associatedRef.coeffs }
            this.$store.commit('RefStore/updateRefData', objectToSend )
        },
        nextStep(){
            if(this.isFormValid){
                this.$store.commit('RefStore/changeCurrentStep', { index: 4 })
            }else{
                this.showErrorNotif = true
            }
        },
        firstFriendChange(friendRef){
            this.selectedFriend1 = friendRef
        },
        secondFriendChange(friendRef){
            this.selectedFriend2 = friendRef
        }
    }
}
</script>


<style lang="scss" >
#new_ref_third_step{
    background: $white;
}
.associated_ref_name{
    text-align: center;
    font-weight: 600;
    span{
        text-transform: uppercase;
        color: $grey-light;
    }
}
.model_align_btn{
    cursor: pointer;
}
.coeff_cat_title{
    text-align: left;
    width: 300px;
}
.total_slider_container{
    width: 500px;
}
.widget_helpers{
    // max-width: 900px!important;
    .model_align_btn{
        margin-top: 20px!important;
        margin-bottom: 0px!important;
    }
}
</style>